import React from "react";
import JudgeAddition from "./JudgeAddition";
import AgeGroupAddition from "./AgeGroupAddition";

const JudgeSettings = () => {
    return (
        <div style={{display: "flex"}}>
            <JudgeAddition/>
            <AgeGroupAddition/>
        </div>
    );
}

export default JudgeSettings;